import { useState, useEffect } from "react";
import CustomErrorDialogBox from "./components/CustomErrorDialogBox/CustomErrorDialogBox";
import { useTranslationSetup } from "./utils/useTranslationSetup.js";
import Loading from "./assets/LottieFiles/resultLoading.json";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Lottie from "react-lottie-player";
import "./ResultLoadingScreen.css";
import { SCREENS } from "./utils/CommonUtils/screenConstants.js";
import { Box } from "@mui/material";

const ResultLoadingScreen = ({
  setActiveScreen,
  setAudioBlobForAudioPlayer,
  setHideSlider,
  orfResultStatus,
  setOrfResultStatus,
  setSaveClicked,
  setAudioUploading,
  setStudentName,
  setUploadAudioStatus,
  setAssessmentLang,
}) => {
  const { t } = useTranslationSetup();
  const [openDialogForError, setOpenDialogForError] = useState(false);

  useEffect(() => {
    if (
      orfResultStatus === "UNDETERMINED" ||
      orfResultStatus === "FAILED" ||
      orfResultStatus === "ERROR" ||
      orfResultStatus === "ERR_INTERNET_DISCONNECTED"
    ) {
      setOpenDialogForError(true);
    }
  }, [orfResultStatus]);

  const onClickPrimaryButton = () => {
    setOpenDialogForError(false);
    if (orfResultStatus === "FAILED") {
      setActiveScreen(SCREENS.RENDER_ORF_TEST_SCREEN);
    } else {
      setAssessmentLang(null);
      setActiveScreen(SCREENS.RENDER_ASSESSMENT_LANG_SCREEN);
    }
    setAudioBlobForAudioPlayer(null);
    setHideSlider(false);
    setOrfResultStatus(null);
    setUploadAudioStatus(null);
    setAudioUploading(false);
    setSaveClicked(false);
  };
  const onClickSecondaryButton = () => {
    setOpenDialogForError(false);
    setAudioBlobForAudioPlayer(null);
    setAssessmentLang(null);
    setActiveScreen(SCREENS.RENDER_VS_WELCOME_SCREEN);
    setStudentName("");
    setAssessmentLang(null);
    setHideSlider(false);
    setOrfResultStatus(null);
    setUploadAudioStatus(null);
    setAudioUploading(false);
    setSaveClicked(false);
  };

  return (
    <>
      {orfResultStatus === "UNDETERMINED" && (
        <CustomErrorDialogBox
          header={t("taking_longer_than_usual")}
          subHeader={t("assessment_taking_longer_than_usual")}
          icon={<RestoreOutlinedIcon className="restore-icon" />}
          primaryButtonText={t("New Language")}
          secondaryButtonText={t("new_student")}
          isDialogOpen={openDialogForError}
          showPrimaryButton={true}
          showSecondaryButton={true}
          onClickPrimaryButton={onClickPrimaryButton}
          onClickSecondaryButton={onClickSecondaryButton}
        />
      )}
      {(orfResultStatus === "FAILED" ||
        orfResultStatus === "ERROR" ||
        orfResultStatus === "ERR_INTERNET_DISCONNECTED") && (
        <CustomErrorDialogBox
          header={t("something_went_wrong")}
          icon={<ErrorOutlineOutlinedIcon className="error-outline-icon" />}
          primaryButtonText={orfResultStatus === "FAILED" ? t("retake") : null}
          secondaryButtonText={t("new_student")}
          isDialogOpen={openDialogForError}
          showPrimaryButton={orfResultStatus === "FAILED"}
          showSecondaryButton={true}
          onClickPrimaryButton={onClickPrimaryButton}
          onClickSecondaryButton={onClickSecondaryButton}
        />
      )}
      <Box className="loader-container">
        <Box className="loader-content">
          <Lottie loop animationData={Loading} play />
          <Box className="loader-heading">{t("processing_result")}</Box>
          <Box className="loader-text">{t("your_audio_saved_please_wait")}</Box>
        </Box>
        <Box className="loader-bottom-text-wrapper">
          <Box className="loader-bottom-text">
            {t("thank_you_for_patience_fine_tuning")}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ResultLoadingScreen;
